import React, { useEffect, useState } from "react";
import { useContext } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import Step1 from "./Step01";
import Step2 from "./Step02";
import Step3 from "./Step03";
import MultiStepProgressBar from "./MultiStepProgressBar";
import '../../assets/css/Booking.css'
import moment from "moment";
import Step4 from "./Step04";
import 'react-notifications/lib/notifications.css';
import { BookingContext } from "./BookingContext";
import { LoginContext } from "../../LoginContext";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { addbooking } from "../../Api/frontbooingApi";
import { SignUp } from "../../Api/frontbooingApi";


const MasterForm = () => {

    const [currentStep, setCurrentStep] = useState(1);
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [address, setAddress] = useState("");
    const [usertype, setUsertype, chooseservice, setChooseservice, choosesubservice, setChoosesubservice, chooseaddon, setChooseaddon, choosetechnician, setChoosetechnician, choosedate, setChoosedate, choosetime, setChoosetime, userDetails, setUserDetails, paymentDetails, setPaymentDetails, Totalpayment, setTotalpayment, totalDuration, setTotalDuration, appointmentNotes, setAppointmentNotes, servicename, setServicename, endchoosetime, setEndchoosetime,confirmpassword , setConfirmpassword] = useContext(BookingContext);
    const { LoggedInData, login, logout } = useContext(LoginContext);
    const [billedhours, setBilledhours] = useState("0");
    
    console.log("paymentDetails",paymentDetails);


    const UserSignUp = () => {
        if (userDetails.password != confirmpassword) {
            NotificationManager.error('Password and confirm password should be same', 'Close after 3000ms', 3000);
            return false;
        }


        const formData = new FormData();
        formData.append("email", userDetails.user_email);
        formData.append("password", userDetails.password);
        formData.append("confirmpassword", confirmpassword);
        formData.append("first_name", userDetails.first_name);
        formData.append("last_name", userDetails.last_name);
        formData.append("phone", userDetails.phone);
        formData.append("zipcode", userDetails.zip);
        formData.append("address", userDetails.address);
        formData.append("state", userDetails.state);
        formData.append("city", userDetails.city);
        formData.append("user_type", "0");
        SignUp(formData).then((res) => {
            if (res.code === 200) {
                if (res.data.status == '1') {
                    const apiResponse = res.data;
                    login(apiResponse.data);
                }
                else {
                    //get error message 
                    if (res.data.message) {
                        var error = res.data.message.match(/<p>(.*?)<\/p>/g);
                        var errorString = "";
                        error.forEach(element => {
                            errorString += element.replace("<p>", "").replace("</p>", "") + "\n";
                        });
                        NotificationManager.error(errorString, 'Close after 3000ms', 3000);
                    }
                }

            } else {
                alert("Something went wrong");
            }
        });

    }




    const handleChange = event => {
        const { name, value } = event.target;
        switch (name) {
            case "email":
                setEmail(value);
                break;
            case "username":
                setUsername(value);
                break;
            case "password":
                setPassword(value);
                break;
            case "address":
                setAddress(value);
                break;
            default:
                break;
        }
    };

    const nextStep = () => {
        setCurrentStep(prevStep => prevStep >= 3 ? 4 : prevStep + 1);
    };

    const prevStep = () => {
        setCurrentStep(prevStep => prevStep <= 1 ? 1 : prevStep - 1);
    };

    const previousButton = () => {
        if (currentStep !== 1) {
            return (
                <Button color="secondary float-left" className="wizard-btn" onClick={prevStep}>
                    Previous
                </Button>
            );
        }
        return null;
    };

    const nextButton = () => {
        if (currentStep < 4) {
            if (currentStep == 1) {
                if (chooseservice.length == 0) {

                    return (
                        <Button color="primary float-right" className="wizard-btn" disabled> Next </Button>
                    );
                }
                else {
                    return (
                        <Button color="primary float-right" className="wizard-btn" onClick={nextStep}>
                            Next
                        </Button>
                    );
                }
            }
            else if (currentStep == 2) {
                if (choosetechnician.length == 0 || choosedate.length == 0 || choosetime.length == 0) {
                    return (
                        <Button color="primary float-right" className="wizard-btn" disabled> Next </Button>
                    );
                }
                else {
                    return (
                        <Button color="primary float-right" className="wizard-btn" onClick={nextStep}>
                            Next
                        </Button>
                    );
                }
            }
            else if (currentStep == 3) {

                // return (
                //     <Button color="primary float-right" className="wizard-btn" onClick={UserSignUp} > Next </Button>
                // );


                if (LoggedInData != null) {

                    return (
                        <Button color="primary float-right" className="wizard-btn" onClick={nextStep}>
                            Next
                        </Button>
                    );
                }
                else {
                    return (
                        <Button color="primary float-right" className="wizard-btn" onClick={UserSignUp} > Next </Button>
                    );
                }
                

            }

            else {
                return (
                    <Button color="primary float-right" className="wizard-btn" onClick={nextStep}>
                        Next
                    </Button>
                );
            }
        }
        return null;
    };

    const submitButton = () => {
        if (currentStep > 3) {
            return <Button color="primary float-right" className="wizard-submit-btn" onClick={AddBookingData}>Submit</Button>;
        }
        return null;
    };

    const getTimeData = () => {
        const start_time = totalDuration;
        var hours = Math.floor(start_time / 60);
        var minutes = start_time % 60;
        var ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        var time = "0" + hours + ":" + minutes;
        return time;
    }

    const recurringbookingdate = null;
    const recurringtime = null;




    const AddBookingData = () => {
        const formData = new FormData();
        formData.append("user_id", LoggedInData.id);
        formData.append("type", usertype);
        formData.append("service_id", chooseservice);

        // const staffIds = [];
        // for (let i = 0; i < choosetechnician.length; i++) {
        //   staffIds.push(choosetechnician[i].value);
        // }
        formData.append("sub_service_id", JSON.stringify(choosesubservice));
        formData.append("staff_id", choosetechnician);
        formData.append("app_notes", appointmentNotes);
        formData.append("amount", Totalpayment);
        formData.append(
            "client_name",
            LoggedInData.first_name + " " + LoggedInData.last_name
        );
        formData.append("firstname", LoggedInData.first_name);
        formData.append("lastname", LoggedInData.last_name);
        formData.append("client_email", LoggedInData.user_email);
        formData.append("client_phone", LoggedInData.phone);
        formData.append("client_address", LoggedInData.address);
        formData.append("client_city", LoggedInData.city);
        formData.append("client_state", LoggedInData.state);
        formData.append("client_zip", LoggedInData.zip);
        formData.append("client_zone", LoggedInData.zip);
        formData.append("billed_hours", getTimeData());
        formData.append("bedrooms", LoggedInData.bedrooms);
        formData.append("bathrooms", LoggedInData.bathrooms);
        formData.append("user_pwd", LoggedInData.user_pwd);
        const booking_date_time = moment(choosetime).format("YYYY-MM-DD HH:mm:ss");
        const order_date = moment(choosetime).format("YYYY-MM-DD");
        formData.append("booking_date_time", booking_date_time);
        formData.append("order_date", order_date);
        formData.append("payment_date", order_date);
        formData.append("recurring_booking_date", recurringbookingdate);
        formData.append("recurring_time_to", recurringtime);
        formData.append("addons", JSON.stringify(chooseaddon));

        if (recurringbookingdate !== "" && recurringtime !== "" && recurringbookingdate !== null && recurringtime !== null) {
            formData.append("recurring_status", "Y");
        } else {
            formData.append("recurring_status", "N");
        }

        if(paymentDetails != null){
            formData.append("paymentDetails", JSON.stringify(paymentDetails));
            formData.append("customer_id", LoggedInData.customer_id);
        }
        

        addbooking(formData).then((res) => {
            if (res.code === 200) {
                if (res.data.status === "1") {
                    NotificationManager.info('Booking Added Successfully');
                    window.location.href = "/dashboard";
                } else {
                    alert("Booking Not Added");
                }
            } else {
                alert("Something went wrong");
            }
        });



        // }
        // setValidated(true);
    };

    return (
        <>
            {/* <Form> */}
            <div className="card booking-form-card">
                <div className="card-body">
                    <div className="card-title">
                        <MultiStepProgressBar currentStep={currentStep} />
                    </div>
                    <Step1
                        currentStep={currentStep}
                        handleChange={handleChange}
                        email={email}
                    />
                    <Step2
                        currentStep={currentStep}
                        handleChange={handleChange}
                        email={username}
                    />
                    <Step3
                        currentStep={currentStep}
                        handleChange={handleChange}
                        email={password}
                    />
                    <Step4
                        currentStep={currentStep}
                        handleChange={handleChange}
                        email={address}
                    />
                </div>
                <div className="card-footer booking-card-btn-footer">
                    {previousButton()}
                    {nextButton()}
                    {submitButton()}
                </div>
            </div>
            <NotificationContainer />
            {/* </Form> */}
        </>
    );
}

export default MasterForm;
